export default __webpack_public_path__ + "static/media/Imperator.a3b1aee3.ttf";